export function getScrollbarSize(thin: boolean = true): { width: number; height: number } {
    if (typeof document === 'undefined' || !document.body) {
        return { width: 0, height: 0 };
    }

    const el = document.createElement('div');

    if (thin) {
        el.style.setProperty('scrollbar-width', 'thin');
    }

    // Minimal, hidden measuring element
    el.style.position = 'absolute';
    el.style.top = '-9999px';
    el.style.width = '100px';
    el.style.height = '100px';
    el.style.overflow = 'scroll';
    el.style.boxSizing = 'content-box';

    document.body.appendChild(el);

    const width = Math.max(0, el.offsetWidth - el.clientWidth);
    const height = Math.max(0, el.offsetHeight - el.clientHeight);

    document.body.removeChild(el);

    return { width, height };
}